<template>
    <div class="project_empty">
        <h4 style="color: #606060;margin-top: -20px;margin-left: 250px;"><i style="font-size: 43px;position: relative; left: -9px;bottom: -10px;" class="material-icons">chevron_left</i>No Projects found. Please add one.</h4>
    </div>
</template>

<script>
export default {
    name: "ProjectEmpty"
};
</script>
